
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqlUAEN_HwMvTEHpkgRrZk2UDKCnrlGQPwoMVHjbrAiaMMeta } from "/codebuild/output/src1705621318/src/src/pages/faq.vue?macro=true";
import { default as menuidA9vd2mCZ2BxEHssZWMrH4Stqw_45FM0oB4G_45CqXJVSIMeta } from "/codebuild/output/src1705621318/src/src/pages/menu.vue?macro=true";
import { default as indexJh1_1y5odx6sFSH1QoDkzPAjhvQFXd2SCzZYS3GNZhYMeta } from "/codebuild/output/src1705621318/src/src/pages/index.vue?macro=true";
import { default as contactuarNwT0FwnBGCF_45u4Gbv_45g0CKmdnqCe8DfVhxP3_ZpYMeta } from "/codebuild/output/src1705621318/src/src/pages/contact.vue?macro=true";
import { default as tutorial0hhRD6_45eHylsksUlPhsQpvlArhyAWe5CtYkogKMeb2cMeta } from "/codebuild/output/src1705621318/src/src/pages/tutorial.vue?macro=true";
import { default as agreementQ5S5yvmYiaeDZqGpsXgk81rRpE6pk3nn_45PhQshPt1rUMeta } from "/codebuild/output/src1705621318/src/src/pages/agreement.vue?macro=true";
import { default as about_45passLVOxEeoub_WbhY_n0cve9YBqmu_45jh8rEPqcln0olIhUMeta } from "/codebuild/output/src1705621318/src/src/pages/about-pass.vue?macro=true";
import { default as indexgEgULw6q8S2Gy_45RWdNCuJ0xgoW0FS_F0w0mGUNzaunEMeta } from "/codebuild/output/src1705621318/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93w_BwkLQTGPGpGzD6f4ycxPed1DjU_zZ8e34wtMp9Fq8Meta } from "/codebuild/output/src1705621318/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceoIWiybyNYjBgwwhv9PQ0hWbOG64i6gGD4orzv0SVxakMeta } from "/codebuild/output/src1705621318/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93YGUr6G4_458L1xlznF6Har1MY22Me1CtVDoY3YHOW_BFYMeta } from "/codebuild/output/src1705621318/src/src/pages/notice/[id].vue?macro=true";
import { default as indexwE9pRnK2FqfU_bnQ_45ibGNkip3YLUzyaTT5rV8YE2x_45sMeta } from "/codebuild/output/src1705621318/src/src/pages/coupon/index.vue?macro=true";
import { default as indexaff_zeJC_gbjORxkI2VvbRBH5obyo5OV2UmWZUj_45K_0Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/index.vue?macro=true";
import { default as indexKCoT_45JC2sUUEF4vQoG7CPVkjFfZ0CF3Uqb14_RfumosMeta } from "/codebuild/output/src1705621318/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93b_45DKuLGJcpcaEXFkMrOgQSbNFpxgV0KY_2XS53lPvS0Meta } from "/codebuild/output/src1705621318/src/src/pages/parking/[id].vue?macro=true";
import { default as indexpZIxTB1sf4t_Ln8TcHAncBME2HpdPvLfEOsNl_45MQWEkMeta } from "/codebuild/output/src1705621318/src/src/pages/history/index.vue?macro=true";
import { default as index6DhiH2y_jGUXycmcxk_MRqgzOMzJxrDbdrIZFH0Ny18Meta } from "/codebuild/output/src1705621318/src/src/pages/monthly/index.vue?macro=true";
import { default as index7E_OIvUc7r1pHHeTgN0KEmJFy8SwnPE_V5keW9LsK_45AMeta } from "/codebuild/output/src1705621318/src/src/pages/sign-in/index.vue?macro=true";
import { default as index_IE5ku6IiqByzy_454r28p6ngnG1_4591oz1MAEJq9nDjMoMeta } from "/codebuild/output/src1705621318/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavia_RyNZ8HHcB_NqibJfqYx1Mmta_s4kwJ_45HsFsbueWKMMeta } from "/codebuild/output/src1705621318/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editP5KbGnOQVJgEVG40W8xhrfHFbg_Et34z4rHwWnnf27sMeta } from "/codebuild/output/src1705621318/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementsdFCp0pCHWdKdh2abJ57P3FChe3qH8tFyG4roeDcYE8Meta } from "/codebuild/output/src1705621318/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexUAFp7f6gs163VHAoMRunNoKCI89HkyI_455XOb6FkGLY8Meta } from "/codebuild/output/src1705621318/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d5vikYJnT_45HFbh8M4MHknOz7y_457mQ_45Qo3_45_45PnYu_45IEwcMeta } from "/codebuild/output/src1705621318/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmxLxbMP6zanHIufW7TGK2_45vEIvmp8dTKnJp9k8l7naG0Meta } from "/codebuild/output/src1705621318/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexw8c_45jPVWDGsMiJvN7p_IWFH5KS08BTNBA6Be3dO24z4Meta } from "/codebuild/output/src1705621318/src/src/pages/card/create/index.vue?macro=true";
import { default as indexzP3Oux_457uxSqHmeNBS5sUsFj5dz_45Cpg7Lf0B__6aDrUMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmEHAkpWVqbz_W6NgyOUz5HphIIiRzkYzPDE_StIHf7KgMeta } from "/codebuild/output/src1705621318/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmV4ZpIP9e3zbJqZdGlbtrtCYff6qdT2h_45eAmyifzcRnMMeta } from "/codebuild/output/src1705621318/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete7z4rK_ofrbOMEZ8CB__gwxMd13tF0o0klo9eq7dbf0kMeta } from "/codebuild/output/src1705621318/src/src/pages/membership/complete.vue?macro=true";
import { default as registerQP910N5Du_45xdASjku1EnLjdNnWiH2UXbJdKUZqKl_45hsMeta } from "/codebuild/output/src1705621318/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93xgWA5KvPMA5v9UprwhiAnk5T4ANvteht8qvN5ZIHTt4Meta } from "/codebuild/output/src1705621318/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmoddNfWfxAP9p3A_45k2K8DGYaIYofFmCmy5kiSmyrKNb4Meta } from "/codebuild/output/src1705621318/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93Aj67491LfGWKafxJjjlQIZbFL6CBoBhOGsWREItDoRwMeta } from "/codebuild/output/src1705621318/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexSQHrab88iRauM2yrxd5EnBLcLFx4o9vn2YPfEfKCZw0Meta } from "/codebuild/output/src1705621318/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeBdgH9u_45G0VMZtwVskCIB_45_45JgYnQ2hFIivje7QURvX80Meta } from "/codebuild/output/src1705621318/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code7jMWLV3n0ANvcKk3Ix_muG2otx3ggtcQshsq2ht7BEgMeta } from "/codebuild/output/src1705621318/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completevGWbLaiQAPSPTGaTi7_45fKoQCAzdGcCR70B04TJjRG9sMeta } from "/codebuild/output/src1705621318/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerMoZoFsiaFAy0xbEBH_45rLYFNFbepm4LSr7pOTEHcLVnUMeta } from "/codebuild/output/src1705621318/src/src/pages/contact-form/register.vue?macro=true";
import { default as completef61dqPWsSJ0yRVbOwo_RHFiUOfofIw_45I6LWzppks_MQMeta } from "/codebuild/output/src1705621318/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexqRqpxnJ_6Gj_fphJxRvRlgIzN68VUzTB4D53bzihQGUMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmlBIgbqvPr_45yVMh2GmgDHjBpb1AJdn0mu2jBjPOzsE20Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeg_45gK8VedYllq2yIG4GdEX32gg4PErtWGztofxG_7yYMMeta } from "/codebuild/output/src1705621318/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexvtw7c3h5GYK5J7cMQcLUcOBqgUTUXKT8oTF0IZhF8g4Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_933kJNb9IfHbT5AO_whoa6lWBJE3SU3LUR8d1dU4LwnHcMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete4kaFDf27PqryHTLihfqUnKSb_45ARzEnWndcMiz_JCJVgMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasvC5zTw7KF_rEKdTpHdAZAWxWvqYQAv5AthNQcfPDrKYMeta } from "/codebuild/output/src1705621318/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleVZSHKKLd5lohXlHyupDfSSZMnlKvRXFRHhO3OieAU6EMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailzmH_45scspi0nJTgK9nf_hnhEh4r0ygyAr_45C_sFoJWzQgMeta } from "/codebuild/output/src1705621318/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmnqdz7p9TAG0bKLJQjQz7CJ_45_HbFOpjLQCnPDSg1JnT8Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentXZ_45RdcdNd7eAv5WKpTnrBM0u7Za5StWvKUTrXKiDCE8Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmoEC6uaO7_45g_45TcVRyOp01i28cHuOSJP3RHz153TKjSokMeta } from "/codebuild/output/src1705621318/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateatgjQqbo0jzSU3pu1kLr56jISmoEjKYVifDKzk1WL1kMeta } from "/codebuild/output/src1705621318/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completehuaLmN8ssul8Nlbn4IPaVreYgRkCEmg85sIT2eVaWGYMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codefvb06NYrDxTTIsOsbiVCdc9temfz2Rnh1K54iKrvbXYMeta } from "/codebuild/output/src1705621318/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordsYtMh_45xLArKs42eUTLiSI9IZt17Ffz_45wTlfjBP23tmEMeta } from "/codebuild/output/src1705621318/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasH57y_45vQCtVdG1AH0NHool4NHP8gQ_mcaONhyDQNbgL0Meta } from "/codebuild/output/src1705621318/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerzoxx9IkGJnJqRhFJkijt_45g9dn2aQfW43ef5dlNe6bE8Meta } from "/codebuild/output/src1705621318/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeXo6aOOOuEwN_Pcu5U_45SR81mOVGm5l4rBbwqA4JFqrBIMeta } from "/codebuild/output/src1705621318/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexohg5DYknXHGmx74mNvezh_45bpaIJoMeETswLt9rKOmK8Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexpGjuo9GIeRwbamYbPs8a9L2LVS9TfQ9ZLit5jN4uxYIMeta } from "/codebuild/output/src1705621318/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index6TxIcgfTsPVocw1RRRkbB_q_EEkuWON_45mVN5ppULVrwMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexeCmkYirEV55HzpgzbLLGfF7ioqht4KNCWaHp4xXAuFsMeta } from "/codebuild/output/src1705621318/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateo1xdTK2Cg1xYWv13H3nrGIzPBD9dfhJjgTAE0ryYUEgMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeGZU2fWCn_5dwkSyrYuZ4tGZd4tGPZhxCxL5XgZhkOEcMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmZ0_jCq8Y6dMfBQ5Ld8pfX5fHgDJU4Wh0QKxwaqtYy64Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexwacMdlR0VGXJwujumWhWDqY5xzOdJyADkm_pGV4Xvz4Meta } from "/codebuild/output/src1705621318/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeL4sCpy6tJQkmdda11kP9sKyssm9yRImB8tcYj8zrSBMMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatelrMwsSrNU_45wGzuKT6TmcGjmw1DQ4jvbjFzTbHOP3w94Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexFt_PcFJF7FZ6my2wvuWIRpw6NW8nZEq9qzDXIAnorP4Meta } from "/codebuild/output/src1705621318/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexRiGcBBfX_45DLKQsOLBi37gEvVidI0pbzDkLwq4f_45kaw0Meta } from "/codebuild/output/src1705621318/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeCkp_45kU0f_y6LfgE_38RF1z7IP8NcGPvznYqwLHyGJPQMeta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexRfy_451JEjxHvGISSeGpfeD2dQ80_45EhT6xpsv8PfScSfsMeta } from "/codebuild/output/src1705621318/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codebu1ATMgaPN0xguoPymM7kh6OZrUZuzcSSPL77V_45ntp0Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexy8F0gsi81R0QXtBPXguKZK4b7SrKeMLj_45gFauoPsCw4Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index8T2L2pxtnCoa9jw_45sF8Pnh_UTYY9ij7SDChd4BPaTyAMeta } from "/codebuild/output/src1705621318/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexcId8bvxvWrEQN30_NZgBVEY25FUqPEJMDJT5gsb6wTQMeta } from "/codebuild/output/src1705621318/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatetMXK7v9zes95q5xU5DAlmGv9tq_krWITRnuBqfQY4T0Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmtP1GKYnahuzFtWS5QRLjT4twbE736ALZeysRmebC904Meta } from "/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuidA9vd2mCZ2BxEHssZWMrH4Stqw_45FM0oB4G_45CqXJVSIMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexJh1_1y5odx6sFSH1QoDkzPAjhvQFXd2SCzZYS3GNZhYMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexwE9pRnK2FqfU_bnQ_45ibGNkip3YLUzyaTT5rV8YE2x_45sMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexpZIxTB1sf4t_Ln8TcHAncBME2HpdPvLfEOsNl_45MQWEkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index7E_OIvUc7r1pHHeTgN0KEmJFy8SwnPE_V5keW9LsK_45AMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index_IE5ku6IiqByzy_454r28p6ngnG1_4591oz1MAEJq9nDjMoMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexw8c_45jPVWDGsMiJvN7p_IWFH5KS08BTNBA6Be3dO24z4Meta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmEHAkpWVqbz_W6NgyOUz5HphIIiRzkYzPDE_StIHf7KgMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmV4ZpIP9e3zbJqZdGlbtrtCYff6qdT2h_45eAmyifzcRnMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete7z4rK_ofrbOMEZ8CB__gwxMd13tF0o0klo9eq7dbf0kMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerQP910N5Du_45xdASjku1EnLjdNnWiH2UXbJdKUZqKl_45hsMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmoddNfWfxAP9p3A_45k2K8DGYaIYofFmCmy5kiSmyrKNb4Meta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeBdgH9u_45G0VMZtwVskCIB_45_45JgYnQ2hFIivje7QURvX80Meta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code7jMWLV3n0ANvcKk3Ix_muG2otx3ggtcQshsq2ht7BEgMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completevGWbLaiQAPSPTGaTi7_45fKoQCAzdGcCR70B04TJjRG9sMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerMoZoFsiaFAy0xbEBH_45rLYFNFbepm4LSr7pOTEHcLVnUMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmlBIgbqvPr_45yVMh2GmgDHjBpb1AJdn0mu2jBjPOzsE20Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeg_45gK8VedYllq2yIG4GdEX32gg4PErtWGztofxG_7yYMMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexvtw7c3h5GYK5J7cMQcLUcOBqgUTUXKT8oTF0IZhF8g4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete4kaFDf27PqryHTLihfqUnKSb_45ARzEnWndcMiz_JCJVgMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleVZSHKKLd5lohXlHyupDfSSZMnlKvRXFRHhO3OieAU6EMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailzmH_45scspi0nJTgK9nf_hnhEh4r0ygyAr_45C_sFoJWzQgMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmnqdz7p9TAG0bKLJQjQz7CJ_45_HbFOpjLQCnPDSg1JnT8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentXZ_45RdcdNd7eAv5WKpTnrBM0u7Za5StWvKUTrXKiDCE8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmoEC6uaO7_45g_45TcVRyOp01i28cHuOSJP3RHz153TKjSokMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completehuaLmN8ssul8Nlbn4IPaVreYgRkCEmg85sIT2eVaWGYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codefvb06NYrDxTTIsOsbiVCdc9temfz2Rnh1K54iKrvbXYMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordsYtMh_45xLArKs42eUTLiSI9IZt17Ffz_45wTlfjBP23tmEMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerzoxx9IkGJnJqRhFJkijt_45g9dn2aQfW43ef5dlNe6bE8Meta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeXo6aOOOuEwN_Pcu5U_45SR81mOVGm5l4rBbwqA4JFqrBIMeta || {},
    component: () => import("/codebuild/output/src1705621318/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1705621318/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]